__webpack_require__.p = "https://sim.tlk-energy.de/diagrams/logph/";